import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import Backend from "i18next-http-backend";

import { APP_LANG } from "config.js";

i18n.use(Backend)
    .use(initReactI18next)
    .init({
        lng: APP_LANG,
        debug: false,
        interpolation: {
            escapeValue: false,
        },
        supportedLngs: ["ru", "en"],
        backend: {
            loadPath: "/locales/{{lng}}/{{ns}}.json",
            requestOptions: {
                cache: "no-store",
            },
        },
    });

export default i18n;
